
/**
 * Randomizes the order of elements in an array.
 * @param {Object[]} array The array to shuffle. It will be mutated.
 * @return {Object[]} The shuffled array
 */
export const shuffle = function (array) {
    if (array) {
        for (let i = array.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            const temp = array[i];
            array[i] = array[j];
            array[j] = temp;
        }
    }
    return array;
};

/**
 * Returns $max random elements from the array
 * @param {T[]} array The array to shuffle. It will be mutated.
 * @param {Number} max The number of elements to return
 * @return {T[]} The selected elements
 * @template T
 */
export const shuffleAndTruncate = function (array, max) {
    if (array && array.length >= max) {
        shuffle(array);
        array.length = max;
    }
    return array;
};

/**
 * Returns $max random indices into the array
 * @param {Object[]} array The array to select indices from
 * @param {Number} max The number of indices to return
 * @return {Number[]} The selected indices
 */
export const randomIndices = function (array, max) {
    return shuffleAndTruncate(array.map((x, i) => i), max);
};

/**
 * Returns an array containing the elements at the listed indices
 * @param {T[]} array The array to extract from
 * @param {Number[]} indices The indices of the elements we want
 * @return {T[]} The elements at the selected indices
 * @template T
 */
export const extractElementsAtIndices = function (array, indices) {
    return indices.map(i => array[i]);
};

/**
 * Selects a random element from an array
 * @param {Object[]} array
 * @return {Object} The randomly selected element
 */
export const randomElement = function (array) {
    if (array) {
        return array[Math.floor(array.length * Math.random())];
    }
};
